/**
 * Onglet « Référentiels » : la préparation des matchings de la campagne.
 *
 * Une cible par test qui en porte une (attentes du poste pour le PAMI, culture
 * d'entreprise pour le PC Fit). Pour chacune : l'objet produit (configuration,
 * consensus, figement), puis les personnes qui le produisent (référents,
 * invitations, relances).
 *
 * Sorti des onglets de test, où Référentiel et Référents se lisaient comme des
 * résultats au même titre que les Résultats et le Matching.
 */
import { ControleSegmente } from "../elementsNavigation";
import {
  LIBELLE_CIBLE,
  type CibleReferentiel,
} from "../ongletsCampagne";
import type { Id } from "../../../../convex/_generated/dataModel";
import { ReferentielTab } from "./ReferentielTab";
import { ReferentsTab } from "./ReferentsTab";

type Props = {
  campagneId: Id<"campagnes">;
  /** Cibles portées par la campagne, dans l'ordre des tests. */
  cibles: readonly CibleReferentiel[];
  cible: CibleReferentiel;
  onChoisirCible: (cible: CibleReferentiel) => void;
  /** Cibles dont le référentiel existe déjà sur la campagne. */
  ciblesConfigurees: readonly CibleReferentiel[];
  lectureSeule: boolean;
};

export function OngletReferentiels({
  campagneId,
  cibles,
  cible,
  onChoisirCible,
  ciblesConfigurees,
  lectureSeule,
}: Props) {
  const configure = ciblesConfigurees.includes(cible);
  return (
    <div className="space-y-6">
      {cibles.length > 1 && (
        <ControleSegmente
          libelle="Référentiel"
          options={cibles.map((c) => ({ valeur: c, libelle: LIBELLE_CIBLE[c] }))}
          valeur={cible}
          onChoisir={onChoisirCible}
        />
      )}
      {/* `key` : changer de cible remonte les deux blocs, sinon un état local
          (brouillon de configuration, formulaire d'invitation) passerait d'un
          référentiel à l'autre. */}
      <ReferentielTab
        key={`referentiel-${cible}`}
        campagneId={campagneId}
        cible={cible}
        lectureSeule={lectureSeule}
      />
      {configure && (
        <ReferentsTab
          key={`referents-${cible}`}
          campagneId={campagneId}
          cible={cible}
          lectureSeule={lectureSeule}
        />
      )}
    </div>
  );
}
